import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';
import { formatDate as formatDateLocale } from '../../../utils/dateFormat.js';
import ErrorMessage from '../ErrorMessage.js';
import '../../weight/lots/WeightLots.css';

const formatNoteDate = (d) => {
  const dt = new Date(d);
  return formatDateLocale(dt) + ' ' + dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

const LotNotes = () => {
  const { lotId } = useParams();
  const { t }     = useTranslation();
  const [notes,        setNotes]        = useState([]);
  const [newNote,      setNewNote]      = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const loadNotes = () => {
    Fetch(`api/data/lots.notes?search_fields=lot_id&search_values=${lotId}`,
      'get', null,
      (d) => setNotes((d || []).sort((a, b) => a.created_at.localeCompare(b.created_at)))
    );
  };

  useEffect(() => { loadNotes(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAdd = () => {
    if (!newNote.trim()) return;
    setIsSubmitting(true);
    setErrorMessage('');
    const user = JSON.parse(localStorage.getItem('zapmanejo_user') || '{}');
    Fetch('api/data/lots.notes', 'post',
      JSON.stringify({
        lot_id:     Number(lotId),
        author:     user.name || user.email || 'Unknown',
        note:       newNote.trim(),
        created_at: new Date().toISOString(),
      }),
      () => { setNewNote(''); setIsSubmitting(false); loadNotes(); },
      () => { setIsSubmitting(false); setErrorMessage(t('error_saving')); }
    );
  };

  return (
    <div className="wld-page">
      <div className="wld-subpage-title">{t('lotNotes')}</div>

      {notes.length === 0 ? (
        <div className="wl-empty-note">{t('noNotes')}</div>
      ) : (
        <div className="wl-notes-list">
          {notes.map((n, i) => (
            <div key={i} className="wl-note-item">
              <div className="wl-note-meta">
                <span className="wl-note-author">{n.author}</span>
                <span className="wl-note-date">{formatNoteDate(n.created_at)}</span>
              </div>
              <div className="wl-note-text">{n.note}</div>
            </div>
          ))}
        </div>
      )}

      <div className="wld-note-add">
        <textarea className="wl-note-input" placeholder={t('writeNote')}
          value={newNote} onChange={e => setNewNote(e.target.value)} rows={3} />
        <button className="wld-note-add-btn" onClick={handleAdd}
          disabled={isSubmitting || !newNote.trim()}>
          {isSubmitting ? t('adding') : t('addNote')}
        </button>
      </div>
      <ErrorMessage message={errorMessage} />
    </div>
  );
};

export default LotNotes;
